import React from "react";

function SvgIcMapPoi115(props) {
  return (
    <svg width="1em" height="1em" viewBox="0 0 32 32" {...props}>
      <g fill="none" fillRule="evenodd">
        <path
          d="M22 18.997h-4v4h-4v-4h-4v-4h4v-4h4v4h4v4zm2-10c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H8c-1.1 0-2-.9-2-2v-12c0-1.1.9-2 2-2zm-6-5c2.318 0 4 1.052 4 2.5v1.5h-2v-1.5c-.08-.085-.798-.5-2-.5h-4c-1.202 0-1.92.415-2.018.587L12 7.998h-2v-1.5c0-1.45 1.682-2.5 4-2.5h4z"
          fill="#FFF"
        />
      </g>
    </svg>
  );
}

export default SvgIcMapPoi115;
